module.exports = __webpack_public_path__ + "static/media/shaker_snap_01.689d3025.wav";